<div class="theme-container" id="tableWrapper" [ngClass]="[selectedPagetab === 'scrubber' ? 'newscrubberClassAdded' : '',selectedPagetab === 'lng' ? 'newlngClassAdded' : '']">
  <div class="theme-container-inner">
    <!-- Page Breadcrumb Start -->
    <div class="breadcrumb-main breadcrumb-width">
      <div class="breadcrumb-Skelton-section" *ngIf="distribution.isSkelton">
        <div class="breadcrumb__left">
          <h1 class="sektion-filter"><span class="Skelton-pp"></span></h1>
          <p><span class="Skelton-pp"></span></p>
        </div>
        <div class="breadcrumb__right">
          <div class="buttons-grp df-c"> <span class="Skelton-pp"></span>
          </div>
        </div>
      </div>
      <snl-breadcrumb *ngIf="!distribution.isSkelton">
        <div left-side>
          <h1 class="header-h1 fw-700 color__primary">Distribution</h1>
          <p class="m-0 body-b1 fw-400 color__primary">The overall collection by all the ships part of the
            {{distribution.fleet}} pool has been calculated and shown here.</p>
          <div class="bannerToggle" *ngIf="showBannerToggleVal || showBannerToggleval_"
            [ngClass]="selectedPagetab === 'dist' ? 'addDistwidth' : 'addScrubberWidth'">
            <figure>
              <img src="assets/img/information.svg" alt="information">
            </figure>
            <!-- <span class="body-b1" *ngIf="showBannerToggleVal">We are processing {{previousMonth}} data. It will be
              available by <span class="bannerDate section-title"> 06 {{currentDate | slice:0:3}}
                {{currentYear}}.</span> </span> -->
            <span class="body-b1" *ngIf="showBannerToggleVal">We are processing {{previousMonth}} data. It will be
              available by <span class="bannerDate section-title"> {{ calculationDate | date:'dd MMM yyyy' }}.</span> </span>
            <span class="body-b1" *ngIf="showBannerToggleval_">We are still processing {{previousMonth}} data, and it
              will be available shortly.</span>
          </div>
        </div>
      </snl-breadcrumb>
    </div>
    <!-- Page Breadcrumb End -->


    <!-- Container Card Start -->
    <div class="CommonContainerCard  border__radius8"[ngClass]="[selectedPagetab === 'scrubber' ? 'scrubberClassAdded' : '',selectedPagetab === 'lng' ? 'lngClassAdded' : '',filteredShipPools?.length < 2 && distribution.fleet !== 'SNAPS' ? 'addedFilterdClass' : '']">
      <div class="action-panel-main">        
        <div class="tab">
          <snl-page-tab class="distributionTab" [isSelected]="selectedPagetab === 'dist' ? true : false "
            (onPageTabClick)="clickTab('dist')">Distribution</snl-page-tab>
          <ng-container *ngIf="showScrubbertab">
            <snl-page-tab class="scrubberTab" [isSelected]="selectedPagetab === 'scrubber' ? true : false "
            (onPageTabClick)="clickTab('scrubber')">Scrubber</snl-page-tab>
          </ng-container>
          <ng-container *ngIf="showLNGtab">
             <snl-page-tab class="lngTab" [isSelected]="selectedPagetab === 'lng' ? true : false" 
              (onPageTabClick)="clickTab('lng')">LNG</snl-page-tab>
          </ng-container>
          <snl-date-picker-dropdown class="distDate" *ngIf="distribution.maxDate && !distribution.isSkelton " datePickerType="month"
            title='Month' [min]="distribution.minDate" [max]="distribution.maxDate" [startMonthDate]="distribution.maxDate"
            (selectedDate)=selectedDate($event)>
          </snl-date-picker-dropdown>
        </div>
        <ng-container *ngIf="selectedPagetab == 'dist'">
          <snl-action-panel class="pt-24">
            <div left-side class="CommonFiltersPanel df-c">
              <div class="ResetFiltersTxt body-b fw-700 df-c justify-content-start col-gap-16">                
                <div class="Skelton-section" *ngIf="distribution.isSkelton">
                  <div class="sektion-filter"><span class="Skelton-pp"></span></div>
                  <div class="dropdown-sektion"><span class="Skelton-pp"></span></div>
                  <div class="dropdown-sektion"><span class="Skelton-pp"></span></div>
                  <div class="dropdown-sektion"><span class="Skelton-pp"></span></div>
                  <div class="dropdown-sektion"><span class="Skelton-pp"></span></div>
                </div>
                <span class="color__primary section-title" *ngIf="!distribution.isSkelton">Filter(s)</span>
                <a *ngIf="!distribution.isSkelton" href="javascript:void(0);"
                  [ngClass]="{'active': resetActivate() == true}" class="ResetAllTxt resetAllFlTxt section-title" (click)="resetAll()">Reset all</a>
              </div>
              <div class="dropdown-col _TextFltr _TextSubPool" *ngIf="!distribution.isSkelton">
                <snl-dropdown [label]="'Pool'" [buttonPrimary]="'Apply'" [buttonSecondary]="'Clear'"
                  [options]="distribution.subpool" [preSelectedItems]="subPools"
                  (selectedValues)="selectedValues($event,'subpool')" (resetDropdown)="resetDropdown($event,'subpool')"
                  [multiple]="true"></snl-dropdown>
              </div>
              <div class="dropdown-col _TextFltr _TextShipOwner " *ngIf="!distribution.isSkelton">
                <snl-dropdown [label]="'Ship owner'" [buttonPrimary]="'Apply'" [buttonSecondary]="'Clear'"
                  [options]="distribution.shipOwner" [preSelectedItems]="shipOwners"
                  (selectedValues)="selectedValues($event,'shipOwners')"
                  (resetDropdown)="resetDropdown($event,'shipOwners')" [multiple]="true"></snl-dropdown>
              </div>
              <div class="dropdown-col _TextFltr _TextShipClass" *ngIf="!distribution.isSkelton">
                <snl-dropdown [label]="'Ship class'" [buttonPrimary]="'Apply'" [buttonSecondary]="'Clear'"
                  [options]="distribution.vslClass" [preSelectedItems]="vslClasses"
                  (selectedValues)="selectedValues($event,'vslClass')"
                  (resetDropdown)="resetDropdown($event,'vslClass')" [multiple]="true"></snl-dropdown>
              </div>
              <div class="dropdown-col _TextFltr _TextShip" *ngIf="!distribution.isSkelton">
                <snl-dropdown [label]="'Ship'" [buttonPrimary]="'Apply'" [buttonSecondary]="'Clear'"
                  [options]="distribution.ship" [preSelectedItems]="shipNames"
                  (selectedValues)="selectedValues($event,'ship')" (resetDropdown)="resetDropdown($event,'ship')"
                  [multiple]="true"></snl-dropdown>
              </div>
            </div>
            <div right-side class="rightSideFilterPanel">
              <div class="distributionModal">
                <ng-container *ngIf="open">
                  <snl-modal (click)="cancel()" [type]="'medium'" [open]="open">
                    <div slot="heading">Customise my view</div>
                    <div slot="modalContent" class="customise-view-model-content">
                      <span class="body-b1">Reorder, show or hide columns that are being displayed on the distribution
                        table.</span>
                      <div cdkDropList [cdkDropListData]="distributionColData" (cdkDropListDropped)="drop($event)"
                        class="drag-drop-list">
                        <div *ngFor="let item of distributionColData; let i = index; trackBy: trackByIndex" cdkDrag
                          (cdkDragStarted)="isDragging = true" (cdkDragEnded)="isDragging = false" [attr.data-index]="i"
                          [ngClass]="{
                            'dragging': dragStartindex === i,
                            'fade-other-items': isDragging && dragStartindex !== i,                          
                          }" class="drag-drop-item">

                          <!-- Drag Handle -->
                          <div cdkDragHandle class="dragDrop">
                            <img src="assets/img/drag.png" alt="drag">
                          </div>

                          <!-- Checkbox -->
                          <snl-checkbox [isDisable]="false" [checked]="item.hidden === false" [intermediate]="false"
                            [id]="'checkBox-' + i" [value]="item?.value" (onClick)="selectShipname(item)">
                            {{item?.name}}
                          </snl-checkbox>
                        </div>
                      </div>
                    </div>
                    <div slot="modalFooter">
                      <snl-button size="large"
                        [disabled]="!storeDistributionModalData?.length && !this.storeCheckedvalue?.length && !enableApplybtn"
                        (click)="applyModalUpdataData()">Apply</snl-button>
                      <snl-button size="large" type="secondary" [disabled]="!resetToDefault" (click)="reset()">Reset to
                        default settings</snl-button>
                      <span class="section-title cancel" (click)="cancel()">Cancel</span>
                    </div>
                  </snl-modal>
                </ng-container>
                <snl-button size="large" type="tertiary" class="customiseViewBtn section-title"
                  *ngIf="filteredShipPools?.length || shipPools?.length" (click)="open = true"
                  [disabled]="!checkColumnLength?.length">Customise my view</snl-button>
              </div>
              <div class="monthlyYearlylables" *ngIf="filteredShipPools?.length || shipPools?.length">
                <snl-button-toggle (onChange)="getYtdMonthlyVal($event)" [labels]="['YTD','Monthly']"
                  [disabled]="toggleDisabled" [alignment]="'horizontal'"
                  [defaultActive]="defaultActive"></snl-button-toggle>
              </div>
            </div>
          </snl-action-panel>
        </ng-container>
      </div>
      <ng-container *ngIf="selectedPagetab == 'dist'">
        <div class="table distributionTable" *ngIf="tableHeaderdata?.length" [ngClass]="[isScrolled ? 'showDuplicateHeader' : 'hideDuplicateHeader',
        calcDistributionColDataLength <= 12 ? 'hideExternalScroll' : 'showExternalScroll',
        calcDistributionColDataLength <= 8 ? 'hideExternalScroll_1' : 'showExternalScroll_1',
        calcDistributionColDataLength <= 7 ? 'hideExternalScroll_2' : 'showExternalScroll_2',
        calcDistributionColDataLength <= 6 ? 'hideExternalScroll_3' : 'showExternalScroll_3',
        calcDistributionColDataLength <= 5 ? 'hideExternalScroll_4' : 'showExternalScroll_4',
        calcDistributionColDataLength <= 4 ? 'hideExternalScroll_5' : 'showExternalScroll_5',
        calcDistributionColDataLength <= 2 ? 'changeTableWidth' : '',
        showOverHeadScrubberLNGVoyage ? 'changeTableWidth_2' : '',
        ]">
          <div class="showTableHeader" [ngClass]="isHeaderScrolling ? 'scrollingStarted':''" [style.max-width.px]="offsetWidth"   #showTableHeder (scroll)="onHorizontalScroll('header')">
            <snl-table [useTopScroll]="true" class="expandable-table">
              <snl-row class="headerRow " [ngClass]="isScrolled ? 'distTableScrolled' : ''">
                <ng-container *ngFor="let items of tableHeaderdata;trackBy: trackByValue">
                  <ng-container *ngIf="!items?.hidden && showColumn(items?.value)">
                    <snl-th class="headerCol {{items?.value}}">
                      <span>{{items?.name}}
                        <snl-tooltip position="bottom" [config]="toolTipConfig" *ngIf="items?.showTooltip"
                          class="f-right">
                          <span>
                            <figure>
                              <img src="assets/img/Info.svg" alt="img">
                            </figure>
                          </span>
                          <div tooltipContent class="tooltip-padding">
                            <div class="body-b">
                              <app-static-data *ngIf="items?.value === 'poolInPerOpDaysAmt'" [poolInPerOpDays]="true"
                                [forTooltip]="true"></app-static-data>
                              <app-static-data *ngIf="items?.value === 'relShare'" [relativeShareInPool]="true"
                                [forTooltip]="true"></app-static-data>
                              <app-static-data *ngIf="items?.value === 'grossDistribution'" [grossDistribution]="true"
                                [forTooltip]="true"></app-static-data>
                              <app-static-data *ngIf="items?.value === 'poolOut'" [poolOut]="true"
                                [forTooltip]="true"></app-static-data>
                              <app-static-data *ngIf="items?.value === 'overheadFee'" [overheadfee]="true"
                                [forTooltip]="true"></app-static-data>
                              <app-static-data *ngIf="items?.value === 'commissionFee'" [commissionFee]="true"
                                [forTooltip]="true"></app-static-data>
                              <app-static-data *ngIf="items?.value === 'bunkerFee'" [bunkerProcurementFee]="true"
                                [forTooltip]="true"></app-static-data>
                              <app-static-data *ngIf="items?.value === 'managementFee'" [managementfee]="true"
                                [forTooltip]="true"></app-static-data>
                              <app-static-data *ngIf="items?.value === 'netPoolOut'" [netPoolOut]="true"
                                [forTooltip]="true"></app-static-data>
                              <app-static-data *ngIf="items?.value === 'netPoolOutPerOpDaysAmt'"
                                [netPoolOutPerOpDays]="true" [forTooltip]="true"></app-static-data>
                              <app-static-data *ngIf="items?.value === 'profitShare'" [profitSharing]="true" [note]="true"
                                [forTooltip]="true"></app-static-data>
                              <app-static-data *ngIf="items?.value === 'finalPayout' && showFinalPayout"
                                [finalPayout]="true" [note]="true" [forTooltip]="true"></app-static-data>
                            </div>
                          </div>
                        </snl-tooltip>
                      </span>
                    </snl-th>
                  </ng-container>
                </ng-container>
              </snl-row>
            </snl-table>
          </div>
          <div class="distTable" [ngClass]="isHeaderScrolling ? 'scrollingStarted':''"  #distTable (scroll)="onHorizontalScroll('body')">
            <snl-table [useTopScroll]="false" class="expandable-table">
              <snl-row class="headerRow" >
                <ng-container *ngFor="let items of tableHeaderdata;trackBy: trackByValue">
                  <ng-container *ngIf="!items?.hidden && showColumn(items?.value)">
                    <snl-th class="headerCol {{items?.value}}">
                      <span>{{items?.name}}
                        <snl-tooltip position="bottom" [config]="toolTipConfig" *ngIf="items?.showTooltip"
                          class="f-right">
                          <span>
                            <figure>
                              <img src="assets/img/Info.svg" alt="img">
                            </figure>
                          </span>
                          <div tooltipContent class="tooltip-padding">
                            <div class="body-b">
                              <app-static-data *ngIf="items?.value === 'poolInPerOpDaysAmt'" [poolInPerOpDays]="true"
                                [forTooltip]="true"></app-static-data>
                              <app-static-data *ngIf="items?.value === 'relShare'" [relativeShareInPool]="true"
                                [forTooltip]="true"></app-static-data>
                              <app-static-data *ngIf="items?.value === 'grossDistribution'" [grossDistribution]="true"
                                [forTooltip]="true"></app-static-data>
                              <app-static-data *ngIf="items?.value === 'poolOut'" [poolOut]="true"
                                [forTooltip]="true"></app-static-data>
                              <app-static-data *ngIf="items?.value === 'overheadFee'" [overheadfee]="true"
                                [forTooltip]="true"></app-static-data>
                              <app-static-data *ngIf="items?.value === 'commissionFee'" [commissionFee]="true"
                                [forTooltip]="true"></app-static-data>
                              <app-static-data *ngIf="items?.value === 'bunkerFee'" [bunkerProcurementFee]="true"
                                [forTooltip]="true"></app-static-data>
                              <app-static-data *ngIf="items?.value === 'managementFee'" [managementfee]="true"
                                [forTooltip]="true"></app-static-data>
                              <app-static-data *ngIf="items?.value === 'netPoolOut'" [netPoolOut]="true"
                                [forTooltip]="true"></app-static-data>
                              <app-static-data *ngIf="items?.value === 'netPoolOutPerOpDaysAmt'"
                                [netPoolOutPerOpDays]="true" [forTooltip]="true"></app-static-data>
                              <app-static-data *ngIf="items?.value === 'profitShare'" [profitSharing]="true" [note]="true"
                                [forTooltip]="true"></app-static-data>
                              <app-static-data *ngIf="items?.value === 'finalPayout' && showFinalPayout"
                                [finalPayout]="true" [note]="true" [forTooltip]="true"></app-static-data>
                            </div>
                          </div>
                        </snl-tooltip>
                      </span>
                    </snl-th>
                  </ng-container>
                </ng-container>
              </snl-row>
              <ng-container *ngFor="let items of filteredShipPools?.length ? filteredShipPools : shipPools;trackBy: trackByValue">
                <div class="sub-heading-s1 padding-vertical subPoolSection">
                  <span>Pool {{items?.subpoolName}}</span>
                </div>
                <snl-row class="pool-header-row subPoolSection">
                  <snl-td>
                    <div class="pool-header">
                      <div class="body-b" *ngIf="items?.overheadCharges !== null">
                        Daily overhead rate ($)
                        <span class="section-title">{{items?.overheadCharges | negativeToBracket}}</span>
                      </div>
                      <div *ngIf="items?.showScrubberSavings">
                        <div class="body-b">
                          Scrubber savings ($)
                          <span class="section-title"
                            *ngIf="toggleVal === 'Monthly' && items?.scrubberSavingsMonthly !== null">{{items?.scrubberSavingsMonthly
                            | negativeToBracket}}</span>
                          <span class="section-title"
                            *ngIf="toggleVal !== 'Monthly' && items?.scrubberSavings !== null">{{items?.scrubberSavings |
                            negativeToBracket}}</span>
                        </div>
                      </div>
                      <div class="body-b" *ngIf="items?.showLNGSavings">
                        LNG savings ($)
                        <span class="section-title" *ngIf="items?.lngSavingsYTD !== null">{{items?.lngSavingsYTD | negativeToBracket}}</span>
                      </div>
                      <div *ngIf="toggleVal === 'Monthly'">
                        <div class="body-b" *ngIf="items?.accountingVoyageMonthly !== null">
                          Shared pool expenses ($)
                          <span class="section-title">{{items?.accountingVoyageMonthly | negativeToBracket}}</span>
                        </div>
                      </div>
                      <div *ngIf="toggleVal !== 'Monthly'">
                        <div class="body-b" *ngIf="items?.accountingVoyage !== null">
                          Shared pool expenses ($)
                          <span class="section-title">{{items?.accountingVoyage | negativeToBracket}}</span>
                        </div>
                      </div>
                    </div>
                  </snl-td>
                </snl-row>
                <ng-container *ngFor="let shipDeatils of items?.vesselsMonthlyData;trackBy: trackByValue">
                  <snl-row class="distance-row">
                    <snl-td class="shipNameOWner">
                      <span *ngIf="shipDeatils?.canSeeShipLevelCalculation" class="section-title addColor"
                        (click)="getCalculationEvent(shipDeatils)">{{shipDeatils?.vslName}}</span>
                      <span *ngIf="!shipDeatils?.canSeeShipLevelCalculation"
                        class="section-title">{{shipDeatils?.vslName}}</span>
                      <br><span class="body-b3">{{ownersLabel[shipDeatils?.vslOwner]}}</span>
                    </snl-td>

                    <ng-container *ngFor="let col of distributionColData;trackBy: trackByValue">
                      <ng-container *ngIf="!col?.hidden && col?.colHeaderYTD">
                        <snl-td class="{{col.value}}">
                          <ng-container *ngIf="getTrimmedHeader(col) === 'relShareYTD' else notRelShare">
                            <span class="tdText dist-text-color">{{(shipDeatils[getTrimmedHeader(col)] * 100) | negativeToBracket }}</span>
                          </ng-container>
                          <ng-template #notRelShare>
                            <ng-container *ngIf="shipDeatils?.offHireCurrentMonth && getTrimmedHeader(col) === 'opDaysYTD' || shipDeatils?.offHirePreviousMonth && getTrimmedHeader(col) === 'opDaysYTD'">
                              <div class="wrapText" (click)="offHire = true;getoffHireEvent(shipDeatils);triggerGTMEvent(GoogleAnalyticsEvents.OPEN_POOL_POINT_MODAL);"
                                *ngIf="toggleVal !== 'Monthly'"
                                [ngClass]="shipDeatils?.offHireCurrentMonth ? 'addErrorcolor' : (shipDeatils?.offHirePreviousMonth ? 'addColor' : '')">
                                <figure>
                                  <img *ngIf="shipDeatils?.offHireCurrentMonth"
                                    src="assets/img/Warning.svg" alt="img">
                                  <span class="tdText section-title">{{ shipDeatils[getTrimmedHeader(col)] | negativeToBracket}}</span>
                                </figure>
                              </div>
                            </ng-container>
                            <ng-container  *ngIf="!(shipDeatils?.offHireCurrentMonth && getTrimmedHeader(col) === 'opDaysYTD') && !(shipDeatils?.offHirePreviousMonth && col?.colHeaderYTD?.trim() === 'opDaysYTD')">
                              <div class="wrapText" *ngIf="toggleVal !== 'Monthly'" >
                                <ng-container *ngIf="(shipDeatils?.hasPoolPointUpdateinCurrentMonth || shipDeatils?.hasPenaltyinCurrentMonth) && getTrimmedHeader(col) === 'poolPoint'; else hasPenaltyPrevMonth">
                                  <div [ngClass]="(shipDeatils?.hasPoolPointUpdateinCurrentMonth || shipDeatils?.hasPenaltyinCurrentMonth) && getTrimmedHeader(col) === 'poolPoint' ? 'addErrorcolor' : ''">
                                    <figure (click)="poolPointsModel = true;getPoolPointsModalData(shipDeatils);triggerGTMEvent(GoogleAnalyticsEvents.OPEN_POOL_POINT_MODAL);">
                                      <img src="assets/img/Warning.svg" alt="img" />
                                      <span class="tdText section-title dist-text-color">{{ shipDeatils[getTrimmedHeader(col)] | negativeToBracket }}</span>
                                    </figure>
                                  </div>                           
                                </ng-container>
                                <ng-template #hasPenaltyPrevMonth>
                                  <ng-container *ngIf="shipDeatils?.hasPenaltyinPreviousMonth  && getTrimmedHeader(col) === 'poolPoint'; else noWarningPoolPoint">
                                  <div [ngClass]="shipDeatils?.hasPenaltyinPreviousMonth  && getTrimmedHeader(col) === 'poolPoint' ? 'addColor' : ''">
                                      <figure (click)="poolPointsModel = true;getPoolPointsModalData(shipDeatils);triggerGTMEvent(GoogleAnalyticsEvents.OPEN_POOL_POINT_MODAL);">
                                        <span class="tdText section-title dist-text-color">{{ shipDeatils[getTrimmedHeader(col)] | negativeToBracket }}</span>
                                      </figure>
                                  </div>                             
                                  </ng-container>
                                </ng-template>
                                <ng-template #noWarningPoolPoint>
                                  <figure>
                                    <span class="tdText dist-text-color" *ngIf=" getTrimmedHeader(col) !== 'profitSharingContrAmtYTD'">{{
                                      shipDeatils[getTrimmedHeader(col)] | negativeToBracket }}</span>
                                    <span class="tdText dist-text-color" *ngIf=" getTrimmedHeader(col) === 'profitSharingContrAmtYTD'">
                                      {{ shipDeatils?.isElegibleForProfitSharing ? (shipDeatils[getTrimmedHeader(col)] | negativeToBracket) : 'N/A' }}
                                    </span>
                                  </figure>
                                </ng-template>                        
                              </div>
                            </ng-container>
                            <ng-container *ngIf="shipDeatils?.offHireCurrentMonth && getTrimmedHeader(col) === 'opDays'">
                              <div class="wrapText" (click)="offHire = true;getoffHireEvent(shipDeatils);triggerGTMEvent(GoogleAnalyticsEvents.OPEN_OPERATING_DAYS_MODAL)"
                                *ngIf="toggleVal === 'Monthly'"
                                [ngClass]="[shipDeatils?.offHireCurrentMonth && getTrimmedHeader(col) === 'opDays' ? 'addErrorcolor' : '']">
                                <figure>
                                  <img src="assets/img/Warning.svg" alt="img">
                                  <span class="tdText section-title dist-text-color">{{ shipDeatils[getTrimmedHeader(col)] | negativeToBracket}}</span>
                                </figure>
                              </div>
                            </ng-container>
                            <ng-container *ngIf="!(shipDeatils?.offHireCurrentMonth && getTrimmedHeader(col) === 'opDays')">
                              <div class="wrapText" *ngIf="toggleVal === 'Monthly'" [ngClass]="(shipDeatils?.hasPoolPointUpdateinCurrentMonth || shipDeatils?.hasPenaltyinCurrentMonth) && getTrimmedHeader(col) === 'poolPoint' ? 'addErrorcolor' : ''">
                                <ng-container *ngIf="(shipDeatils?.hasPoolPointUpdateinCurrentMonth || shipDeatils?.hasPenaltyinCurrentMonth) && getTrimmedHeader(col) === 'poolPoint'; else noWarningPoolPoint">
                                  <figure (click)="poolPointsModel = true;getPoolPointsModalData(shipDeatils);triggerGTMEvent(GoogleAnalyticsEvents.OPEN_POOL_POINT_MODAL);">
                                  <img src="assets/img/Warning.svg" alt="img" />
                                    <span class="tdText section-title dist-text-color">{{ shipDeatils[getTrimmedHeader(col)] | negativeToBracket }}</span>
                                  </figure>
                                </ng-container>
                                <ng-template #noWarningPoolPoint>
                                  <figure>
                                    <span class="tdText dist-text-color" *ngIf="getTrimmedHeader(col) !== 'profitSharingContrAmt' ">{{
                                      shipDeatils[getTrimmedHeader(col)] | negativeToBracket }}</span>
                                    <span class="tdText dist-text-color" *ngIf="getTrimmedHeader(col) === 'profitSharingContrAmt'">
                                      <!-- {{ shipDeatils?.isElegibleForProfitSharing ? (shipDeatils[getTrimmedHeader(col)] | negativeToBracket) : 'N/A' }} -->
                                      <ng-container *ngIf="distribution.selectDate.month == 5 || distribution.selectDate.month == 11; else showNA">
                                        {{ shipDeatils?.isElegibleForProfitSharing ? (shipDeatils[getTrimmedHeader(col)] | negativeToBracket) : 'N/A' }}
                                      </ng-container>   
                                      <ng-template #showNA>
                                        N/A
                                      </ng-template>
                                    </span>
                                  </figure>
                                </ng-template>
                              </div>                   
                            </ng-container>
                          </ng-template>
                        </snl-td>
                      </ng-container>                    
                    </ng-container>

                  </snl-row>
                </ng-container>

              <snl-row class="total-row addbgClass">
                <snl-th class="total">Total value of Pool {{items?.subpoolName}}</snl-th>
                <ng-container *ngFor="let col of distributionColData;trackBy: trackByValue">
                  <snl-th class="{{col.value}}" *ngIf="!col?.hidden && col?.colHeaderYTD">
                    <ng-container *ngIf="getTrimmedHeader(col) === 'relShareYTD' || getTrimmedHeader(col) === 'profitSharingContrAmt' else notRelShare">
                      <span *ngIf="getTrimmedHeader(col) === 'relShareYTD'">{{(items?.poolTotal?.[getTrimmedHeader(col)] ?
                        (items?.poolTotal?.[getTrimmedHeader(col)] * 100) : 0) | negativeToBracket }}</span>
                      <span *ngIf="getTrimmedHeader(col) === 'profitSharingContrAmt'">
                        <ng-container *ngIf="toggleVal !== 'Monthly' || distribution.selectDate.month == 5 || distribution.selectDate.month == 11; else showNA">
                          {{items?.poolTotal?.[getTrimmedHeader(col)] ? ((items?.poolTotal?.[getTrimmedHeader(col)]) | negativeToBracket) : "N/A"}}
                        </ng-container>   
                        <ng-template #showNA>
                          N/A
                        </ng-template>                        
                      </span>
                      <!-- <span *ngIf="getTrimmedHeader(col) === 'poolPoint'">N/A</span> -->
                    </ng-container>
                    <ng-template #notRelShare>
                       <span>{{(items?.poolTotal?.[getTrimmedHeader(col)]) | negativeToBracket}}</span>
                    </ng-template>
                  </snl-th>
                </ng-container>
              </snl-row>

            </ng-container>
            <ng-container *ngIf="filteredShipPools?.length || shipPools?.length">
              <snl-row class="grandTotal">
                <snl-th class="grandtotal_">Total</snl-th>
                <ng-container *ngFor="let col of distributionColData; trackBy: trackByValue">
                  <snl-th class="{{col.value}}" *ngIf="!col.hidden && showColumn(col?.value)">
                    <ng-container *ngIf="getTrimmedHeader(col) === 'relShareYTD' else notRelShare">
                      <span>{{col.colHeaderYTD ? ((grandTotalValues[getTrimmedHeader(col)] * 100) | negativeToBracket) : 0}}</span>
                    </ng-container>
                    <ng-template #notRelShare>
                      <span *ngIf="getTrimmedHeader(col) !== 'profitSharingContrAmt'"><!-- getTrimmedHeader(col) !== 'poolPoint' &&  -->
                        {{col.colHeaderYTD ? (grandTotalValues[getTrimmedHeader(col)] | negativeToBracket) : 0}}
                      </span>
                      <!-- <span *ngIf="getTrimmedHeader(col) === 'poolPoint' ">
                        {{grandTotalValues[getTrimmedHeader(col)]}}
                      </span> -->
                      <span *ngIf="getTrimmedHeader(col) === 'profitSharingContrAmt'">
                        <ng-container *ngIf="toggleVal !== 'Monthly' || distribution.selectDate.month == 5 || distribution.selectDate.month == 11; else showNA">
                          {{grandTotalValues[getTrimmedHeader(col)] | negativeToBracket}}
                        </ng-container>   
                        <ng-template #showNA>
                          N/A
                        </ng-template>                        
                      </span>
                    </ng-template>
                  </snl-th>
                </ng-container>
              </snl-row>
            </ng-container>
            </snl-table>
          </div>
          <div *ngIf="tableHeaderdata?.length">
            <div class="distTable-scrollbar"  #externalScroll (scroll)="onHorizontalScroll('outerScroll')">
              <div class="scrollbar-fake-content" [style.width.px]="tableScrollWidth"></div>
            </div>
          </div>     
        </div>
      </ng-container>
      <ng-container *ngIf="selectedPagetab == 'scrubber' && showScrubbertab">
        <app-scrubber [toggleVal]="toggleVal" [defaultActive]="defaultActive" [maxDate]="distribution.maxDate"
          (scrubberDatalist)="getScrubberdata($event)" (toggleValue)="getToggleval($event)"
          (showDropdownVal)="showDropdownVal($event)"></app-scrubber>
      </ng-container>
      <ng-container *ngIf="selectedPagetab == 'lng' && showLNGtab">
        <app-lng [toggleVal]="toggleVal" [defaultActive]="defaultActive" [maxDate]="distribution.maxDate"
          (toggleValue)="getToggleval($event)"
          (lngDatalist)="getLngdata($event)"
          (showDropdownVal)="showDropdownVal($event)">
        </app-lng>
       </ng-container>

    </div>
    <!-- Container Card End  -->
  </div>
</div>
<div class="downLoadBtn">
  <div class="buttons-grp df-c download-dropdown-wrapper">
    <snl-button [size]="'large'" [trailingIcon]="'fa fa-chevron-down'" (click)="dropDownlist()">
      <span class="df-c col-gap-8">
        <span>Download</span>
      </span>
    </snl-button>
    <ng-container *ngIf="selectedPagetab == 'dist' && showDropdown">
      <div class="custom-dropdwn d-flex flex-column align-items-start body-b1 download-menu"
        (click)="$event.stopPropagation()">
        <a href="javascript:void(0);" (click)="generatePdf(true);triggerGTMEvent(GoogleAnalyticsEvents.DOWNLOAD,{module:GoogleAnalyticsModules.DISTRIBUTION, type:GoogleAnalyticsDownloadTypes.PDF_FULL}); $event.stopPropagation()">Full distribution table as PDF</a>
        <a href="javascript:void(0);" (click)="exportExcelCSV(true);triggerGTMEvent(GoogleAnalyticsEvents.DOWNLOAD, {module:GoogleAnalyticsModules.DISTRIBUTION, type:GoogleAnalyticsDownloadTypes.XLS_FULL}); $event.stopPropagation()">Full distribution table as XLS</a>
        <a href="javascript:void(0);" (click)="generatePdf(false);triggerGTMEvent(GoogleAnalyticsEvents.DOWNLOAD, {module:GoogleAnalyticsModules.DISTRIBUTION, type:GoogleAnalyticsDownloadTypes.PDF_FILTERED}); $event.stopPropagation()"
          *ngIf="showDownloadFilter || shipNames?.length || subPools?.length || shipOwners?.length">Current filtered
          view as PDF</a>
        <a href="javascript:void(0);" (click)="exportExcelCSV(false);triggerGTMEvent(GoogleAnalyticsEvents.DOWNLOAD, {module:GoogleAnalyticsModules.DISTRIBUTION, type:GoogleAnalyticsDownloadTypes.XLS_FILTERED}); $event.stopPropagation()"
          *ngIf="showDownloadFilter || shipNames?.length || subPools?.length || shipOwners?.length">Current filtered
          view as XLS</a>
      </div>
    </ng-container>
    <ng-container *ngIf="selectedPagetab == 'scrubber' && showDropdown">
      <div class="custom-dropdwn d-flex flex-column align-items-start body-b1 download-menu"
        (click)="$event.stopPropagation()">
        <a href="javascript:void(0);" (click)="generatePdf(true);triggerGTMEvent(GoogleAnalyticsEvents.DOWNLOAD,{module:GoogleAnalyticsModules.SCRUBBER, type:GoogleAnalyticsDownloadTypes.PDF_FULL}); $event.stopPropagation()">Full scrubber table as PDF</a>
        <a href="javascript:void(0);" (click)="exportExcelCSV(true);triggerGTMEvent(GoogleAnalyticsEvents.DOWNLOAD, {module:GoogleAnalyticsModules.SCRUBBER, type:GoogleAnalyticsDownloadTypes.XLS_FULL}); $event.stopPropagation()">Full scrubber table as XLS</a>
        <a href="javascript:void(0);" (click)="generatePdf(false);triggerGTMEvent(GoogleAnalyticsEvents.DOWNLOAD, {module:GoogleAnalyticsModules.SCRUBBER, type:GoogleAnalyticsDownloadTypes.PDF_FILTERED}); $event.stopPropagation()" *ngIf="filterdScrubberList?.length">Current
          filtered view as PDF</a>
        <a href="javascript:void(0);" (click)="exportExcelCSV(false);triggerGTMEvent(GoogleAnalyticsEvents.DOWNLOAD, {module:GoogleAnalyticsModules.SCRUBBER, type:GoogleAnalyticsDownloadTypes.XLS_FILTERED}); $event.stopPropagation()" *ngIf="filterdScrubberList?.length">Current
          filtered view as XLS</a>
      </div>
    </ng-container>
    <ng-container *ngIf="selectedPagetab == 'lng' && showDropdown">
      <div class="custom-dropdwn d-flex flex-column align-items-start body-b1 download-menu"
        (click)="$event.stopPropagation()">
        <a href="javascript:void(0);" (click)="generatePdf(true);triggerGTMEvent(GoogleAnalyticsEvents.DOWNLOAD,{module:GoogleAnalyticsModules.LNG, type:GoogleAnalyticsDownloadTypes.PDF_FULL}); $event.stopPropagation()">Full lng table as PDF</a>
        <a href="javascript:void(0);" (click)="exportExcelCSV(true);triggerGTMEvent(GoogleAnalyticsEvents.DOWNLOAD, {module:GoogleAnalyticsModules.LNG, type:GoogleAnalyticsDownloadTypes.XLS_FULL}); $event.stopPropagation()">Full lng table as XLS</a>
        <a href="javascript:void(0);" (click)="generatePdf(false);triggerGTMEvent(GoogleAnalyticsEvents.DOWNLOAD, {module:GoogleAnalyticsModules.LNG, type:GoogleAnalyticsDownloadTypes.PDF_FILTERED}); $event.stopPropagation()" *ngIf="filterdLngList?.length">Current
          filtered view as PDF</a>
        <a href="javascript:void(0);" (click)="exportExcelCSV(false);triggerGTMEvent(GoogleAnalyticsEvents.DOWNLOAD, {module:GoogleAnalyticsModules.LNG, type:GoogleAnalyticsDownloadTypes.XLS_FILTERED}); $event.stopPropagation()" *ngIf="filterdLngList?.length">Current
          filtered view as XLS</a>
      </div>
    </ng-container>
  </div>
</div>

<div *ngIf="offHireData?.length">
  <snl-modal (click)="offHire = false" [type]="'large'" [open]="offHire">
    <div slot="heading" class="ppLargeModalHeading" *ngIf="offHireData?.length"> {{offHireShipName}} operating days - off hire details</div>
    <div slot="modalContent" class="modal-content">
      <app-dynamic-table *ngIf="offHireData?.length" [columnHeader]="columnHeader"
        [tableData]="offHireData" [offHireOpdays]="true"></app-dynamic-table>
    </div>
    <div slot="modalFooter">
      <snl-button size="large" (click)="offHire = false">Close</snl-button>
    </div>
  </snl-modal>
</div>

<!-- Side panel controlled by isCalculationOpen property -->
<snl-side-panel panelType="close" [headerName]="calculationSidePanelHeaderName" size="large"
  [(isOpen)]="isCalculationOpen">
  <div sidePanelContent class="largeSidepanelWidth">
    <app-distribution-calculation *ngIf="calculationResponse?.length" [calculationResponse]="calculationResponse"
      [toggleVal]="toggleVal" [distributionColData]="distributionColData" [selectedMonth]="distribution.selectDate.month"></app-distribution-calculation>
  </div>
  <div sidePanelFooterContent>
    <snl-button type="primary" size="large" (click)="isCalculationOpen = false">Close</snl-button>
  </div>
</snl-side-panel>

<div *ngIf="poolPointsData?.length">
  <snl-modal (click)="poolPointsModel = false" [type]="'large'" [open]="poolPointsModel">
    <div slot="heading" class="ppLargeModalHeading"> {{poolPointShipName}} pool points details</div>
    <div slot="modalContent" class="modal-content">
      <app-dynamic-table *ngIf="poolPointsData?.length" [columnHeader]="poolPointscolumnHeader"
        [distPoolPointsTableData]="poolPointsData" [poolPointsTable]="true"></app-dynamic-table>
    </div>
    <div slot="modalFooter">
      <snl-button size="large" (click)="poolPointsModel = false">Close</snl-button>
    </div>
  </snl-modal>
</div>